<div id="announcement" class="page-layout carded fullwidth inner-scroll">

    <div class="top-bg accent"></div>

    <div class="center">

        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">

            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-0 mr-sm-16" (click)="close()" [routerLink]="'/view/announcement'">
                    <mat-icon style="color: white">arrow_back</mat-icon>
                </button>

                <div fxLayout="column" fxLayoutAlign="start start"
                     [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">

                    <div fxLayout="row" fxLayoutAlign="start center" class="mb-12">
                        <mat-icon class="secondary-text s-24">home</mat-icon>
                        <mat-icon class="secondary-text s-24">chevron_right</mat-icon>
                        <div class="subtitle secondary-text">
                            <span>Anúncios</span>
                        </div>
                        <mat-icon class="secondary-text s-24">chevron_right</mat-icon>
                        <div class="subtitle secondary-text">
                            <span>{{this.isUpdate ? 'Editar Anúncio' : 'Salvar Anúncio'}}</span>
                        </div>
                    </div>

                    <div class="h2" *ngIf="this.isUpdate">
                        # {{announcement.id}} - {{announcement.title}}
                    </div>

                    <div class="logo mb-24 mb-md-0" *ngIf="!this.isUpdate"
                         fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="logo-icon s-32 mr-16"
                                  [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                            business
                        </mat-icon>
                        <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                            Preencha os dados
                        </span>
                    </div>

                </div>
            </div>

            <button mat-raised-button class="fuse-white mt-24 mt-md-0" (click)="update(announcement)"
                    *ngIf="this.isUpdate" [disabled]="saveForm.invalid">
                <span>ATUALIZAR</span>
            </button>

            <button mat-raised-button class="fuse-white mt-24 mt-md-0"
                    (click)="save(announcement)" *ngIf="!this.isUpdate" [disabled]="saveForm.invalid">
                <span>SALVAR</span>
            </button>

        </div>

        <div class="content-card">

            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

                <form fxLayout="column" class="w-100-p" fxLayoutAlign="start" fxFlex="1 0 auto" name="saveForm"
                      [formGroup]="saveForm">

                    <div class="tab-content p-24" fusePerfectScrollbar>
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="100">
                                <mat-label>Título</mat-label>
                                <input matInput placeholder="Título"
                                       name="title"
                                       formControlName="title"
                                       [(ngModel)]="announcement.title"
                                       required>
                                <mat-icon matSuffix style="color: gray;">title</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="100">
                                <mat-label>Descrição</mat-label>
                                <textarea matInput placeholder="Descrição"
                                       name="description"
                                       maxlength="2000"
                                       formControlName="description"
                                       [(ngModel)]="announcement.description"
                                       required>
                                </textarea>
                                <mat-icon matSuffix style="color: gray;">description</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="25">
                                <mat-label>Usuário</mat-label>
                                <mat-select [(ngModel)]="announcement.user"
                                            [compareWith]="compareID"
                                            formControlName="user"
                                            placeholder="Usuário" required>
                                    <mat-select-filter [array]="filteredUsers" placeholder="Pesquisar..."
                                                       (input)="filterUser($event.target.value)"></mat-select-filter>
                                    <mat-option *ngFor="let user of filteredUsers"
                                                [value]="user">{{user.id}} - {{user.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="25">
                                <mat-label>Loja Maçônica</mat-label>
                                <mat-select [(ngModel)]="announcement.shop"
                                            [compareWith]="compareID"
                                            formControlName="shop"
                                            placeholder="Loja Maçônica"
                                            (openedChange)="$event && loadMoreShops()">
                                    <mat-select-filter [array]="filteredShops" placeholder="Pesquisar..."
                                                       (input)="filterShop($event.target.value)"></mat-select-filter>
                                    <mat-option *ngFor="let shop of filteredShops; trackBy: trackByShopId"
                                                [value]="shop">{{shop?.id}} - {{shop?.name}}</mat-option>
                                    <mat-option *ngIf="shopLoading" disabled>
                                        <mat-spinner diameter="20"></mat-spinner> Carregando...
                                    </mat-option>
                                    <mat-option *ngIf="shopHasMoreItems && !shopLoading" (click)="loadMoreShops()" disabled>
                                        Clique para carregar mais...
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="25">
                                <mat-label>Categorias</mat-label>
                                <mat-select multiple
                                            [(ngModel)]="announcement.categories"
                                            [compareWith]="compareID"
                                            formControlName="categorie"
                                            placeholder="Categorias" required>
                                    <mat-select-filter [array]="filteredCategories" placeholder="Pesquisar..."
                                                       (input)="filterCategorie($event.target.value)"></mat-select-filter>
                                    <mat-option *ngFor="let categorie of filteredCategories"
                                                [value]="categorie">{{categorie.id}} - {{categorie.title}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="25">
                                <mat-label>Status</mat-label>
                                <mat-select [(ngModel)]="announcement.status" placeholder="Status"
                                            [ngModelOptions]="{standalone: true}">
                                    <mat-option [value]="'EM_ANALISE'">Free - line</mat-option>
                                    <mat-option [value]="'BASICO'">Básico</mat-option>
                                    <mat-option [value]="'LIBERADO'">Liberado com banner</mat-option>
                                    <mat-option [value]="'CARROSSEL'">Carrossel - índice</mat-option>
                                    <mat-option [value]="'PREMIUM'">Premium(Carrossel - índice)</mat-option>
                                    <mat-option [value]="'CRIADO_APP'">Criado - app</mat-option>
                                    <mat-option [value]="'REJEITADO'">Rejeitado</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="30">
                                <mat-label>Imagem</mat-label>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <img [src]="'data:' + imageContentType + ';base64,' + image"
                                         *ngIf="this.image != null" class="avatar"/>
                                    <img [src]="getImageUrl(announcement.id)"
                                         *ngIf="announcement.id != undefined && !isClearImage" class="avatar"/>

                                    <button mat-icon-button matPrefix *ngIf="nomeArquivo == null"
                                            (click)="f_input.click()">
                                        <mat-icon>attach_file</mat-icon>
                                        Selecione...
                                    </button>

                                    <input type="text text-truncate" readonly matInput
                                           formControlName="nomeArquivo" name="nomeArquivo"/>

                                    <input
                                            type="file"
                                            hidden
                                            accept="image/png"
                                            #f_input
                                            (change)="uploadDocument($event)"
                                    />

                                    <button mat-icon-button matSuffix *ngIf="nomeArquivo != null"
                                            (click)="clearFile(); f_input.value=null">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                                <mat-error *ngIf="saveForm.get('image').hasError('maxContentSize')">
                                    O tamanho total não deve exceder {{maxSize}}MB
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="30">
                                <mat-label>Contatos</mat-label>
                                <mat-select multiple [compareWith]="compareID" [(ngModel)]="announcement.contacts"
                                            formControlName="contacts" placeholder="Contatos">
                                    <mat-option *ngFor="let contact of contacts"
                                                [value]="contact">{{contact.pronounTreatment}} {{contact.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <button mat-raised-button class="mr-12 mb-20"
                                    style="align-content: center; background-color: #960210 !important; color: white !important;"
                                    (click)="openContact()" fxFlex="9">
                                <span>Adicionar</span>
                            </button>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="30">
                                <mat-label>Redes Sociais</mat-label>
                                <mat-select multiple [compareWith]="compareID" [(ngModel)]="announcement.socialNetworks"
                                            formControlName="socialNetworks" placeholder="Redes Sociais / Sites">
                                    <mat-option *ngFor="let social of socialNetworks"
                                                [value]="social">{{getTypeSocialNetwork(social.typeSocialNetwork)}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <button mat-raised-button class="mr-12 mb-20"
                                    style="align-content: center; background-color: #960210 !important; color: white !important;"
                                    (click)="openSocialNetwork()" fxFlex="9">
                                <span>Adicionar</span>
                            </button>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="20">
                                <mat-label>CEP</mat-label>
                                <input matInput placeholder="CEP"
                                       name="zipCode"
                                       maxlength="10"
                                       formControlName="zipCode"
                                       (keyup)="onKeyUp($event)"
                                       [(ngModel)]="announcement.address.zipCode"
                                       mask="00000-000">
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="65">
                                <mat-label>Endereço</mat-label>
                                <input matInput placeholder="Endereço"
                                       name="street"
                                       formControlName="street"
                                       [(ngModel)]="announcement.address.street">
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="15">
                                <mat-label>Número</mat-label>
                                <input matInput placeholder="Número"
                                       name="number"
                                       formControlName="number"
                                       [(ngModel)]="announcement.address.number"
                                >
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                        </div>

                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="20">
                                <mat-label>Estado</mat-label>
                                <mat-select [(ngModel)]="announcement.address.state" formControlName="state"
                                            placeholder="Estado">
                                    <mat-option [value]="">Nenhum</mat-option>
                                    <mat-option *ngFor="let state of states"
                                                [value]="state.acronym">{{state.name}}</mat-option>
                                </mat-select>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="20">
                                <mat-label>Cidade</mat-label>
                                <input matInput placeholder="Cidade"
                                       name="city"
                                       formControlName="city"
                                       [(ngModel)]="announcement.address.city">
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="mr-12" fxFlex="20">
                                <mat-label>Bairro</mat-label>
                                <input matInput placeholder="Bairro"
                                       name="district"
                                       formControlName="district"
                                       [(ngModel)]="announcement.address.district">
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                                <mat-error>
                                    Campo obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="40">
                                <mat-label>Complemento</mat-label>
                                <input matInput
                                       placeholder="Complemento"
                                       formControlName="complement"
                                       [(ngModel)]="announcement.address.complement"
                                       name="complement">
                                <mat-icon matSuffix style="color: gray;">home</mat-icon>
                            </mat-form-field>
                        </div>

                    </div>

                </form>

            </div>

        </div>

    </div>

</div>
